import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import GestaoDeCreditos from "./pages/produto/GestaoDeCreditos";
import ComoFunciona from "./pages/ComoFunciona";
import Funcionalidades from "./pages/Funcionalidades";
import Integracoes from "./pages/Integracoes";
import Seguranca from "./pages/Seguranca";
import CasosDeUso from "./pages/CasosDeUso";
import Recursos from "./pages/Recursos";
import Empresa from "./pages/Empresa";
import Contato from "./pages/Contato";

import PoliticaPrivacidade from "./pages/legal/PoliticaPrivacidade";
import Termos from "./pages/legal/Termos";
import NotFound from "./pages/NotFound";

import Obrigado from "./pages/Obrigado";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/produto/gestao-de-creditos" element={<GestaoDeCreditos />} />
          <Route path="/como-funciona" element={<ComoFunciona />} />
          <Route path="/funcionalidades" element={<Funcionalidades />} />
          <Route path="/integracoes" element={<Integracoes />} />
          <Route path="/seguranca" element={<Seguranca />} />
          <Route path="/casos-de-uso" element={<CasosDeUso />} />
          <Route path="/recursos" element={<Recursos />} />
          <Route path="/empresa" element={<Empresa />} />
          <Route path="/contato" element={<Contato />} />
          
          <Route path="/obrigado" element={<Obrigado />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/privacidade" element={<Navigate to="/politica-privacidade" replace />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
